import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog'
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatInputModule, NgIf],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})

export class DialogComponent {

  @Output() buttonClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreate: EventEmitter<any> = new EventEmitter<any>();
  filename = '';
  createBtnDisabled = true;
  showMessage = false;
  message = 'The filename should not contain special characters or any extension.'

  constructor(@Inject(MAT_DIALOG_DATA) public data: { dialogTitle: string; content: string, newButton: boolean, newButtonName: string, createFile: boolean, filenames: string[] | undefined, newBtnColor: string | undefined},
  ) {
    if (data.newBtnColor === undefined) {
      data.newBtnColor = 'warn';
    }
  }

  onButtonClick() {
    this.buttonClicked.emit();
  }

  onCreateFile() {
    this.onCreate.emit(this.filename);
  }

  onFileNameChange(event: any) {
    this.filename = event.target.value;

    if (this.isDuplicate(this.filename)) {
      this.message = 'A file with this name already exists.';
      this.createBtnDisabled = true;
      this.showMessage = true;
    } else {
      if (this.filename === '') {
        this.createBtnDisabled = true;
      } else {
        if (!this.isValidFilename(this.filename)) {
          this.message = 'The filename should not contain special characters or any extension.'
          this.createBtnDisabled = true;
          this.showMessage = true;

        } else {
          this.showMessage = false;
          this.createBtnDisabled = false;
        }
      }
    }

  }

  private isDuplicate(name: string) {
    if (this.data.filenames) {
      for (const f of this.data.filenames) {
        if (name === f) {
          return true;
        }
      }
    }
    return false;
  }

  private isValidFilename(filename: string): boolean {
    const invalidPattern = /[ <>:"/\\|?*.,;=#@$%^&*!()]/;

    if (invalidPattern.test(filename)) {
      return false;
    }

    if (/\.[a-zA-Z0-9]+$/.test(filename)) {
      return false;
    }

    return true;
  }

}
